import GOOGLE_DOMAINS_DATA_JSON from './google-domains'
import GOOGLE_LENS_COUNTRIES_JSON from './google-lens-countries'
import PROMPTS from './prompts'
import type { CountryCurrencyMapping } from './types'

export const DUPE_TOKEN_ADDRESS = 'fRfKGCriduzDwSudCwpL7ySCEiboNuryhZDVJtr1a1C'
export const DUPE_TOKEN_ADDRESS_DEVNET =
  'Dy3ediRtnESHXi7iKhH4xV2dU4RguHVretBQZEsPm84j'

export const DUPE_TOKEN_ADDRESSES = {
  mainnet: DUPE_TOKEN_ADDRESS,
  devnet: DUPE_TOKEN_ADDRESS_DEVNET,
}

// IMPORTANT: This parameter name must stay in sync with mobile app.
// Changing this will break authentication for existing mobile clients that haven't updated.
export const WEB_AUTH_TOKEN_PARAM = 'session-auth'

export const GOOGLE_DOMAINS_DATA = GOOGLE_DOMAINS_DATA_JSON
export const GOOGLE_LENS_COUNTRIES = GOOGLE_LENS_COUNTRIES_JSON

export enum DupeActivityEventName {
  DesktopExtensionInstall = 'desktop_extension_install',
  SafariExtensionInstall = 'safari_extension_install',
  MobileAppInstall = 'mobile_app_install',
  InviteFriend = 'invite_friend',
  PerformDupe = 'perform_dupe',
  ClickResult = 'click_result',
}

// Test user IDs for development
export const INTERNAL_USER_IDS = [
  'kjMJ9O8CMKOirIz0bvFFHaojGzj2', // rusty
  '7zST2OoYH6ONvQlHRlsTzytfwvj2', // bobby
  '1Qq3yRUq1TbuLOYN4fjOyCB6ugN2', // ramin
  'xs1bNWuYsGQEaXOfpqxhYSRuKeC2', // ramin
  'nvVWZdvcnThbjUe4ubCiZYlQozF3', // crystal
  'FoUtBQ7adoPt5fzcHRgmb1pzfR02', // bobby
  'PCSsJt1DnqXh3CdphhVFAyM5ceY2', // ramin
  'kN4QjCqzARSP953sT3W3REyXQDr2', // bobby
]

export const CLASSIFICATIONS_TO_EXCLUDE = [
  'person',
  'human',
  'woman',
  'man',
  'girl',
  'boy',
  'child',
  'children',
  'infant',
  'baby',
  'people',
  'window',
  'animal',
  'vehicle',
  'plant',
  'potted plant',
  'object',
  'book',
  'cup',
  'bottle',
  'cat',
  'dog',
  'bird',
  'fish',
  'hamster',
  'mouse',
  'horse',
  'pet',
  'sky',
  'cloud',
  'house',
  'building',
  'door',
  'wall',
  'floor',
  'ceiling',
  'roof',
  'human face',
  'curtain',
  'flower',
  'tree',
  'tableware',
  'button',
  'ring',
  'shelf',
  'penguin',
  'panda',
  'elephant',
  'giraffe',
  'zebra',
  'lion',
  'car tire',
  'tyre',
  'tire',
  'wheel',
  'tag',
  'label',
  'antenna',
  'mobile phone',
  'candle',
  'drawer',
  'coffee cup',
  'bowl',
  'plate',
  'cup',
  'glass',
  'bottle',
  'jar',
  'bowl',
  'window',
  'door',
  'wall',
  'floor',
  'ceiling',
  'roof',
  'apple',
  'banana',
  'orange',
  'pear',
  'pineapple',
  'strawberry',
  'watermelon',
  'cushion',
]

// Room Types for Restyling
// Process: Add a room name here, make sure prompts.ts is updated with the negative tokens for that room. room-analysis.ts will use this list.
export const ROOM_TYPES = [
  'living-room',
  'bedroom',
  'dining-room',
  'kitchen',
  'bathroom',
  'foyer',
  'entryway',
  'office',
  'patio',
  'home-theater',
  'playroom',
  'laundry-room',
  'sunroom',
  'home-gym',
  'hallway',
  'library',
  'walk-in-closet',
]

export const OPEN_PHONE_PRO_NUMBER = '+17602847414'

export const DUPE_FACTORY_STORE_KEY = 'https://store.dupe.com'

export const DEFAULT_OG_IMAGE = 'https://dupe.com/assets/dupe-og-v1.png'

export const FIREFOX_ADDON_URL = `https://addons.mozilla.org/en-US/firefox/addon/dupe/`
export const DESKTOP_CHROME_WEB_STORE_URL =
  'https://chromewebstore.google.com/detail/dupe/pkhpcfoaocmmpmphhenoblggeinedlah'

export const APP_STORE_URL =
  'https://apps.apple.com/us/app/dupe-com-up-to-90-savings/id1605692440'

export const IS_TEST =
  process.env.NODE_ENV === 'test' ||
  process.env.TEST === 'true' ||
  process.env.TEST_DATABASE_URL

export const DUPE_STORE_URL = 'https://store.dupe.com'

export const DUPE_COMPARE_TO_COOKIE_KEY = '__dupe_input_compare_to'
export const DUPE_TRADE_TOAST_BANNER_COOKIE_KEY = '__dupe_trade_toast_banner'
export const DUPE_HOME_CATEGORY_SELECTOR_COOKIE_KEY =
  '__dupe_home_category_selector'
export const DUPE_GET_PAID_MODAL_COOKIE_KEY = '__dupe_get_paid_modal'

export const LENS_DOMAINS_TO_EXCLUDE = [
  'cgtrader.com',
  'blendermarket.com',
  'renderhub.com',
  '3dexport.com',
  '3dmodels.org',
  'turbosquid.com',
  'moduspace.sg',
  'us.moduspace.sg',
  'blender.org',
  'cults3d.com',
  'grabcad.com',
  'sketchup.com',
  'sketchfab.com',
  'renderhub.com',
  'greatcatalog.net',
  'zeelproject.com',
  'artstation.com',
  'bendtrade.com',
  'cinziagrassi.com',
  'farraragency.com',
  'addmodel.com',
  '3docean.net',
  'facequad.com',
  'seededhome.com,',
  'cgmood.com',
  'b2brazil.com',
  'dekorate.com',
  'myshopify.com',
  'dhgate.com',
  'wenniejewelry.com',
  '37bracelets.com',
  'lightexcellent.com',
]

export const IMAGEKIT_URL_ENDPOINT = 'https://ik.imagekit.io/carrot/'
export const IMAGEKIT_PUBLIC_KEY = process.env.NEXT_PUBLIC_IMAGEKIT_PUBLIC_KEY
export const IMAGEKIT_PRIVATE_KEY = process.env.IMAGEKIT_PRIVATE_KEY

// For new Imagekit account
export const IMAGEKIT_DUPE_URL_ENDPOINT = 'https://ik.imagekit.io/dupe/'
export const IMAGEKIT_DUPE_PUBLIC_KEY = process.env.IMAGEKIT_DUPE_PUBLIC_KEY
export const IMAGEKIT_DUPE_PRIVATE_KEY = process.env.IMAGEKIT_DUPE_PRIVATE_KEY

export const UTM_PARAMS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
]

export const WSI_SHOP_KEYS = [
  'https://westelm.com',
  'https://www.westelm.com',
  'https://westelm.ca',
  'https://www.westelm.ca',
  'https://www.potterybarn.com',
  'https://potterybarn.com',
  'https://www.potterybarn.ca',
  'https://potterybarn.ca',
  'https://www.potterybarnkids.com',
  'https://potterybarnkids.com',
  'https://www.potterybarnkids.ca',
  'https://potterybarnkids.ca',
  'https://www.pbteen.com',
  'https://pbteen.com',
  'https://www.pbteen.ca',
  'https://pbteen.ca',
  'https://www.rejuvenation.com',
  'https://rejuvenation.com',
  'https://www.rejuvenation.ca',
  'https://rejuvenation.ca',
  'https://www.williams-sonoma.com',
  'https://williams-sonoma.com',
  'https://www.williams-sonoma.ca',
  'https://williams-sonoma.ca',
  'https://www.markandgraham.com',
  'https://markandgraham.com',
  'https://www.markandgraham.ca',
  'https://markandgraham.ca',
  'https://www.greenrow.com',
  'https://greenrow.com',
]

export type ShopifyDiscount = {
  code: string
  value?: number
  percentage?: number
  expires?: Date
  enabled?: boolean
}

export const SHOPIFY_DISCOUNTS: ShopifyDiscount[] = [
  {
    code: 'OMGDUPE',
    percentage: 10,
    enabled: true,
  },
  {
    code: '$DUPE',
    percentage: 10,
    enabled: true,
  },
]

export enum AnalyticsEventName {
  DupeAIChatFeedback = 'Dupe AI Chat Feedback',
  DupeAIChatSubmit = 'Dupe AI Chat Submit',
  DupeAIDrawerOpened = 'Dupe AI Drawer Opened',
  DupeAIFollowUpClicked = 'Dupe AI Follow Up Clicked',
  DupeAIChatToRefine = 'Dupe AI Chat To Refine',
  GetPaidModalVisible = 'Get Paid Modal Visible',
  GetPaidModalClick = 'Get Paid Modal Click',
  RewardsClaimed = 'Rewards Claimed',
  RewardsClaimClicked = 'Rewards Claim Clicked',
  RewardsCashOutClicked = 'Rewards Cash Out Clicked',
  RewardsHeaderTriggerClicked = 'Rewards Header Trigger Clicked',
  HomepageCategorySelected = 'Homepage Category Selected',
  NoURLCTAShown = 'No URL CTA Shown',
  NoURLCTAClick = 'No URL CTA Click',
  NoURLResultClick = 'No URL Result Click',
  HomepageViewed = 'Homepage Viewed',
  RestyleHeaderCTA = 'Restyle Header CTA',
  RestyleBannerCTA = 'Restyle Banner CTA',
  RestyleBannerVisible = 'Restyle Banner Visible',
  RestyleGenerateLimitReached = 'Restyle Generate Limit Reached',
  RestyleReloadStyle = 'Restyle Reload Style',
  RestyleShareClicked = 'Restyle Share Clicked',
  RestyleInputMenuCTA = 'Restyle Input Menu CTA',
  RestyleToggleImageTapped = 'Restyle Toggle Image Tapped',
  RestyleJobCardClick = 'Restyle Job Card Click',
  RestyleButtonClick = 'Restyle Button Click',
  RestyleRoomSelect = 'Restyle Room Select',
  RestyleRatingSubmitted = 'Restyle Rating Submitted',
  RestyleObjectClick = 'Restyle Object Click',
  RestyleShoppableButtonClick = 'Restyle Shoppable Button Click',
  HomeRecentsClick = 'Home Recents Click',
  ProjectDrawerTriggerVisible = 'Project Drawer Trigger Visible',
  ProjectDrawerResultClicked = 'Project Drawer Result Clicked',
  ProjectDrawerEditMode = 'Project Drawer Edit Mode',
  ProjectDrawerTriggered = 'Project Drawer Triggered',
  ProjectProductAdded = 'Project Product Added',
  ProjectProductRemoved = 'Project Product Removed',
  ApplePayButtonClicked = 'Apple Pay Button Clicked',
  SurvicateSurveyDisplayed = 'Survicate Survey Displayed',
  SurvicateQuestionAnswered = 'Survicate Question Answered',
  SurvicateSurveyCompleted = 'Survicate Survey Completed',
  SurvicateSurveyClosed = 'Survicate Survey Closed',
  DeepSearchAuthModalOpened = 'Deep Search Auth Modal Opened',
  DeepSearchAuthCallback = 'Deep Search Auth Callback',
  DeepSearchEnabled = 'Deep Search Enabled',
  DeepSearchSeeResultsClicked = 'Deep Search See Results Clicked',
  DeepSearchFeedbackClicked = 'Deep Search Feedback Clicked',
  DupeAssistantPaywallSkip = 'Dupe Assistant Paywall Skip',
  DupeAssistantInView = 'Dupe Assistant In View',
  DupeAssistantTriggered = 'Dupe Assistant Triggered',
  DupeAssistantChooseIntent = 'Dupe Assistant Choose Intent',
  DupeAssistantSubmit = 'Dupe Assistant Submit',
  DupeAssistantSubmitError = 'Dupe Assistant Submit Error',
  DupeAssistantPaywallClick = 'Dupe Assistant Paywall Click',
  ClickedInputMediaMenu = 'Clicked Input Media Menu',
  ClickedInputMedia = 'Clicked Input Media',
  DupeResultsSort = 'Dupe Results Sort',
  CanvasImageClick = 'Canvas Image Click',
  AuthModalOpened = 'Auth Modal Opened',
  AuthModalClosed = 'Auth Modal Closed',
  AuthModalSendCode = 'Auth Modal Send Code',
  AuthModalSendCodeError = 'Auth Modal Send Code Error',
  AuthModalVerifyCodeError = 'Auth Modal Verify Code Error',
  AuthModalOnboardingSubmit = 'Auth Modal Onboarding Submit',
  AuthModalOnboardingPaywallValidate = 'Auth Modal Onboarding Paywall Validate',
  DupeTradeScheduleCallClicked = 'Dupe Trade Schedule Call Clicked',
  DupeTradeBannerClicked = 'Dupe Trade Banner Clicked',
  DupeTradeBannerClosed = 'Dupe Trade Banner Closed',
  FeaturedDupeDirectCardClicked = 'Featured Dupe Direct Card Clicked',
  DupeDirectPicksMatch = 'Dupe Direct Picks Match',
  DupeDirectPicksView = 'Dupe Direct Picks View',
  DupeDirectModalOpen = 'Dupe Direct Modal Open',
  DupeDirectViewAllClicked = 'Dupe Direct View All Clicked',
  DupeDirectButtonClicked = 'Dupe Direct Button Clicked',
  DupeDirectCheckoutClicked = 'Dupe Direct Checkout Clicked',
  DupeDirectImageZoomed = 'Dupe Direct Image Zoomed',
  DupeDirectRailViewed = 'Dupe Direct Rail Viewed',
  SmartBannerView = 'Smart Banner View',
  SmartBannerClickout = 'Smart Banner Clickout',
  SmartBannerExit = 'Smart Banner Exit',
  DupeDiscoverPreviewClick = 'Dupe Discover Preview Click',
  AppBannerModalShown = 'App Banner Modal Shown',
  AppBannerModalOpenAppClicked = 'App Banner Modal Open App Clicked',
  AppBannerModalStaySafariClicked = 'App Banner Modal Stay Safari Clicked',
  AppLinkClicked = 'App Link Clicked',
  TodayShowBannerClicked = 'Today Show Banner Clicked',
  TodayShowVideoPlayed = 'Today Show Video Played',
  CheckPageViewed = 'Check Page Viewed',
  CheckPageAuthShown = 'Check Page Auth Shown',
  CheckPageButtonClicked = 'Check Page Button Clicked',
  CheckPageReasonSelected = 'Check Page Reason Selected',
  CheckPageTimerSubmit = 'Check Page Timer Submit',
  CheckPageAuthClicked = 'Check Page Auth Clicked',
  CheckPageAuthSuccess = 'Check Page Auth Success',
  CheckPageAuthLaterClicked = 'Check Page Auth Later Clicked',
  UserSignedIn = 'User Signed In',
  UserSignedInError = 'User Signed In Error',
  UserManagePlanClicked = 'Manage Plan Clicked',
  ExtensionInstalled = 'Extension Installed',
  ExtentionPostInstall = 'Extension Post Install',
  ExtensionPostUninstall = 'Extension Post Uninstall',
  ExtensionInstalledWithUser = 'Extension Installed With User',
  ViewedDupeExtensionResultPage = 'Viewed Dupe Extension Result Page',
  ExtensionUpdated = 'Extension Updated',
  PromoClickWayfair = 'Promo Click Wayfair',
  CountrySelector = 'Country Selector',
  PerformedDupe = 'Performed Dupe',
  PerformedDupeInterstitial = 'Performed Dupe Interstitial',
  ViewedDupeResultPage = 'Viewed Dupe Result Page',
  LoadMoreResults = 'Load More Results',
  ExtensionPageViewed = 'Extension Page Viewed',
  ExtensionPriceElementDisplayed = 'Extension Price Element Displayed',
  ExtensionPriceElementClicked = 'Extension Price Element Clicked',
  ResultsExtensionWallShown = 'Results Extension Wall Shown',
  ResultsExtensionWallClick = 'Results Extension Wall Clicked',
  SearchTermEntered = 'Search Term Entered',
  SearchResultClicked = 'Search Result Clicked',
  SendTradeExpertMessage = 'Send Trade Expert Message',
  SendExpertResults = 'Send Expert Results',
  DupeUrlCopied = 'Dupe URL Copied',
  FeaturedDupeCardClicked = 'Featured Dupe Card Clicked',
  DupeProductClicked = 'Dupe Product Clicked',
  DupeResultClicked = 'Dupe Result Clicked',
  DupeAssessmentClicked = 'Dupe Assessment Clicked',
  DupeFeedbackSubmitted = 'Dupe Feedback Submitted',
  HowItWorksClicked = 'How It Works Clicked',
  RemovePhotoClicked = 'Remove Photo Clicked',
  ResultsErrorReload = 'Results Error Reload',
  ResultsErrorShown = 'Results Error Shown',
  DupeShareClicked = 'Dupe Share Clicked',
  DupeFeedbackClicked = 'Dupe Feedback Clicked',
  PageRedirect = 'Page Redirect',
  OurPicksMoreDealsClicked = 'Our Picks More Deals Clicked',
  WayfairBannerClicked = 'Wayfair Banner Clicked',
  ClearanceItemClicked = 'Clearance Item Clicked',
  ExtensionUninstallFeedback = 'Extension Uninstall Feedback',
  ExtensionReinstall = 'Extension Reinstall',
  ExtensionUninstallReasonClicked = 'Extension Uninstall Reason Clicked',
  InputSuggestionClicked = 'Input Suggestion Clicked',
  InputSuggestionsDisplayed = 'Input Suggestions Displayed',
  PushCampaignNotificationSent = 'Push Campaign Notification Sent',
  SafariNativeStylePushSent = 'Safari Native Style Push Sent',
  SafariNativeStylePushShown = 'Safari Native Style Push Shown',
  SafariNativeStylePushTapped = 'Safari Native Style Push Tapped',
  SimilarFindsEmailSent = 'Similar Finds Email Sent',
  UnclaimedCoinsEmailSent = 'Unclaimed Coins Email Sent',
  UnclaimedCoinsPushSent = 'Unclaimed Coins Push Sent',
  ExtensionSidePanel = 'Extension Side Panel',
  ExtensionSidePanelReload = 'Extension Side Panel Reload',
  ExtensionSidePanelOpen = 'Extension Side Panel Open',
  ExtensionSidePanelExpanded = 'Extension Side Panel Expanded',
  ExtensionSidePanelCopied = 'Extension Side Panel Copied',
  ExtensionSidePanelSelectImage = 'Extension Side Panel Select Image',
  ExtensionSidePanelSearch = 'Extension Side Panel Search',
  ExtensionSidePanelFindSimilar = 'Extension Side Panel Find Similar',
  ResultsExtensionTabPressed = 'Results Extension Tab Pressed',
  ResultsExtensionWebStoreLinkClicked = 'Results Extension Web Store Link Clicked',
}

export enum FeatureFlags {
  DupeAIChat = 'dupe-ai-chat', // Enables AI chat for text searches
  DupeAIResultsChat = 'dupe-ai-results-chat', // Chat to refine button on result page
  DupeAIHomepage = 'dupe-ai-homepage', // Enables AI chat experience for image and url searches
  EarlyAccessToggle = 'early-access-toggle',
  OurPicksCategory = 'our-picks-category',
  SeoAnalysis = 'seo-analysis',
  RewardsProgram = 'rewards-program',
  Web3Wallet = 'web3-wallet',
  BnplSurvey = 'bnpl-survey', // BNPL survey on DupeResults.tsx
  RestyleRoom = 'restyle-room',
  RestyleObjectDetection = 'restyle-object-detection',
  ForceAnonymousAuth = 'force-anon-auth',
  ProjectsCtaV1 = 'projects-cta-v1',
  PaywallDrawer = 'paywall-drawer',
  PaywallStripePay = 'paywall-stripe-pay',
  OnboardingPaywallStep = 'onboarding-paywall-step',
  PaywallStripeApplePay = 'paywall-stripe-apple-pay',
  PaywallAutopilotPro = 'paywall-autopilot-pro',
  ResultsSurvey = 'results-survey',
  DupeAssistant = 'dupe_assistant',
  HomeSearchAB = 'home-search-ab',
  PartnerPromoLabel = 'partner-promo-label',
  DupeResultsInterstitial = 'dupe-results-interstitial',
  LudicrousSpeed = 'ludicrous-speed', // experiment (https://us.posthog.com/project/71992/experiments/37842)
  CameraSearch = 'camera_search',
  DesktopExtensionWall = 'desktop_extension_wall',
  TodayShowBanner = 'today-show-banner',
  DesktopExtensionBlockContent = 'desktop_extension_block_content',
  HomeInputSuggestions = 'home_input_suggestions',
  DupeFactoryDirect = 'dupe-factory-direct',
  FactoryDirectCTA = 'factory-direct-cta',
  DesktopExtensionBlockContentMobileSafari = 'desktop_extension_block_content_mobile_safari',
  AlwaysCheckInterstitial = 'always-check',
  SupportsSheetCsvFiles = 'supports_sheet_csv_files',
  EmailPreferences = 'email-preferences',
  RestyleSessionRecording = 'restyle-session-recording', // Controls session recording for restyle users
  InstagramPaidUsers = 'instagram-paid-users', // Controls session recording for Instagram paid users
  ResultsPageExtensionPreview = 'results-page-extension-preview',
  ResultsPageExtensionPreviewSidepanel = 'results-page-extension-preview-sidepanel',
  SerpRefinementList = 'serp-refinement-list',
}

// Old link - https://calendly.com/dupedotcom/dupe-trade-program-onboarding
export const DUPE_TRADE_SCHEDULE_CALL_URL =
  'https://calendly.com/d/cqwq-d5f-8gy/dupe-trade-sourcing-chat'

export const MAX_AGE_OF_COOKIE = 60 * 60 * 24 * 365 // one year in seconds

export const WCTRCK_COOKIE_KEY = '_wctrck'
export const GA_CLIENT_ID_COOKIE_KEY = '_ga'
export const GA_GCL_AW_COOKIE_KEY = '__gcl_aw'

export const TEMP_USER_ID_KEY = '__dupe_temp_user_id'
export const DUPE_AUTH_USER_ID_KEY = '__dupe_auth_user_id'

export const SELECTED_COUNTRY_KEY = '__dupe_selected_country'
export const DEFAULT_COUNTRY = 'us'
export const DUPE_SUPPORTED_COUNTRIES_MAPPING: CountryCurrencyMapping = {
  us: {
    name: 'US',
    value: 'us',
    flag: '🇺🇸',
    currency_symbols: ['USD', 'US$', '$', 'US'],
  },
  ca: {
    name: 'CA',
    value: 'ca',
    flag: '🇨🇦',
    currency_symbols: ['C', 'CAD', 'C$', 'CAD$', '$'],
  },
  gb: {
    name: 'UK',
    value: 'gb',
    flag: '🇬🇧',
    currency_symbols: ['£', '€', 'GBP'],
  },
  fr: {
    name: 'FR',
    value: 'fr',
    flag: '🇫🇷',
    currency_symbols: ['€', 'EUR', 'EURO'],
  },
  de: {
    name: 'DE',
    value: 'de',
    flag: '🇩🇪',
    currency_symbols: ['€', 'EUR', 'EURO'],
  },
  it: {
    name: 'IT',
    value: 'it',
    flag: '🇮🇹',
    currency_symbols: ['€', 'EUR', 'EURO'],
  },
  nl: {
    name: 'NL',
    value: 'nl',
    flag: '🇳🇱',
    currency_symbols: ['€', 'EUR', 'EURO'],
  },
  es: {
    name: 'ES',
    value: 'es',
    flag: '🇪🇸',
    currency_symbols: ['€', 'EUR', 'EURO'],
  },
  au: {
    name: 'AU',
    value: 'au',
    flag: '🇦🇺',
    currency_symbols: ['A', 'A$', '$', 'AUD'],
  },
  nz: {
    name: 'NZ',
    value: 'nz',
    flag: '🇳🇿',
    currency_symbols: ['N', 'NZD', 'NZ$', '$'],
  },
}

export enum UploadFileTypes {
  IMAGE = 'image',
  DOCUMENT = 'document',
}

export enum MessageTypes {
  PING = 'PING',
  AUTH_SYNC = 'AUTH_SYNC',
  MESSAGE_RECEIVED = 'MESSAGE_RECEIVED',
  DUPE_TAB = 'DUPE_TAB',
  CONTEXT_OR_TRAY_ICON = 'CONTEXT_OR_TRAY_ICON',
  ALERT_AM = 'ALERT_AM',
  TRACK_EVENT = 'TRACK_EVENT',
  SIDE_PANEL_OPEN = 'SIDE_PANEL_OPEN',
  IS_SIDEPANEL_OPEN = 'IS_SIDEPANEL_OPEN',
  SIDEPANEL_PDP_STATE = 'SIDEPANEL_PDP_STATE',
  OPEN_SIDEPANEL = 'OPEN_SIDEPANEL',
  IMAGE_SELECTED = 'IMAGE_SELECTED',
  SHOW_SIDEPANEL = 'SHOW_SIDEPANEL',
  CLOSE_SIDEPANEL = 'CLOSE_SIDEPANEL',
  URL_CHANGE = 'URL_CHANGE',
  RESULT_CLICK = 'RESULT_CLICK',
  SIDEPANEL_CLOSED = 'SIDEPANEL_CLOSED',
  SHOW_IMAGE_PICKER = 'SHOW_IMAGE_PICKER',
}

export enum SavedItemSource {
  BOOKMARK = 'bookmark',
}
export const MIGRATE_FORM_URL = 'https://forms.gle/uLA5LUnkB5vnfWh56'
export const MIGRATE_FORM_URL_PREFILL_USERNAME =
  'https://docs.google.com/forms/d/e/1FAIpQLSeKE8baIYxdBhm9ymeEMRn1bUgiz4EEleZCiffv4lVdTAgckA/viewform?entry.1940528030=' // add username at the end

export const EXTENSION_ID = 'pkhpcfoaocmmpmphhenoblggeinedlah' // TODO ensure correct and matches one used on dupe.com

const RAILWAY_DOMAIN =
  process.env.NEXT_PUBLIC_RAILWAY_PUBLIC_DOMAIN ||
  process.env.PLASMO_PUBLIC_RAILWAY_PUBLIC_DOMAIN
export const DUPE_API_URL =
  process.env.NEXT_PUBLIC_DUPE_API_URL ||
  RAILWAY_DOMAIN ||
  'https://api.dupe.com'

export const DUPE_API_STAGING_URL = 'https://api-staging.dupe.com'

// Style options for restyle
export const STYLE_OPTIONS = PROMPTS

// Facebook Pixel ID
export const FB_PIXEL_ID = '1001580568749204'

export const DEEP_SEARCH_SUPPORTED_COUNTRIES = ['us', 'ca']
